export type TagType = {
  id: string;
  title: string;
};
